export default __webpack_public_path__ + "static/image1-a88c0be203593117bd6bab97584ae1b8.png";